import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dqshtg_icon",
  "use": "icon-dqshtg_icon-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-dqshtg_icon\">\n<title>dqshtg_icon</title>\n<path d=\"M27.429 2.286v13.714h-2.286v-11.429h-20.571v22.857h8.030v2.286h-10.316v-27.429z\" />\n<path d=\"M21.714 8v2.286h-13.714v-2.286z\" />\n<path d=\"M17.143 13.714v2.286h-9.143v-2.286z\" />\n<path d=\"M12.571 20.571v2.286h-4.571v-2.286z\" />\n<path d=\"M25.335 19.938l1.902 1.268-5.197 7.795-5.518-3.569 1.241-1.919 3.622 2.344z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol